module.exports = __webpack_public_path__ + "static/main-bacd461393c650188a6da701b0f25603.jpg";